import secureLocalStorage from "react-secure-storage";
import * as React from "react";
import "../../Styles/RiskViews.scss";
import { Grid, GridColumn, GridDetailRow } from "@progress/kendo-react-grid";
import CurrencyFormat from "../Tenant/Component/CurrencyFormat";
import MitigationNameCell from "../Tenant/Component/MitigationNameCell";
import MitigationStatus from "../Tenant/Component/MitigationStatus";

export class MitigationDetails extends GridDetailRow {
  constructor(props) {
    super(props);
    this.state = {};
  }
  //   componentDidMount() {
  //   this.createDynamicColsInMitigation();
  // }
  createDynamicColsInMitigation = async (products) => {
    let impactColumn = [];
    let impactMaster = [];
    if (products && products.length > 0) {
      impactMaster = products[0].impactResponse;
    }
    products.map((res, i) => {
      if (res.impactResponse) {
        res.impactResponse.map((item, j) => {
          if (impactColumn.length > 0) {
            if (!impactColumn.includes(item.name)) {
              impactColumn.push(item.name);
            }
          } else {
            impactColumn.push(item.name);
          }
        });
      }
    });
    
    if (impactColumn.length > 0) {
      products.map((res) => {
        impactColumn.map((col) => {
          let temp = res.impactResponse.filter((item) => item.name === col);
          if (temp.length > 0) {
            res[col] = temp[0].value;
          } else {
            res[col] = undefined;
          }
        });
      });
    }
    let columnsToShow = [];
    if (impactColumn.length > 0) {
      columnsToShow = impactColumn.map((item) => (
        <GridColumn
          field={item}
          title={this.getImpactUnit(item, impactMaster)}
          width="100px"
          editable={false}
          cell={(props) => (
            <CurrencyFormat {...props} onEditCell={this.onEditCell} />
          )}
        />
      ));
    }
    if (!this.state.impactMitigationColumns) {
      products.map((riskReg) => {
        if (riskReg.actualCompletionDate) {
          riskReg.actualCompletionDate = new Date(
            riskReg.actualCompletionDate
          );
        }
        if (riskReg.originalCompletionDate) {
          riskReg.originalCompletionDate = new Date(
            riskReg.originalCompletionDate
          );
        }
        if (riskReg.projectedCompletionDate) {
          riskReg.projectedCompletionDate = new Date(
            riskReg.projectedCompletionDate
          );
        }
        if (riskReg.createdDate) {
          riskReg.createdDate = new Date(
            riskReg.createdDate
          );
        }
        if (riskReg.proximityDate) {
          riskReg.proximityDate = new Date(riskReg.proximityDate);
        }
      });
      this.setState({ ...this.state, impactMitigationColumns: columnsToShow });
    }
  };
  getImpactUnit = (impact, impactMaster) => {
    var impactTemp = impactMaster.find((item) => item.name == impact);
    var res = impact;
    if (impactTemp && impactTemp.name) {
      let unit=impactTemp.units?" / "+impactTemp.units:""
      res = impactTemp.name + unit;
    }
    if (this.props.dataItem.isOpportunity === "Opportunity") {
      return "Increase in " + res;
    } else {
      return "Reduction in " + res;
    }
  };
  approvedCell = (event) => {
    return <td>{event.dataItem.approved ? "Yes" : "No"}</td>;
  };
  onEditCell = () => {};
  render() {
    const data = this.props.dataItem.mitigationResps;

    if (data) {
      this.createDynamicColsInMitigation(data);
      return (
        <div className="riskReportMitigation">
          <Grid data={data} reorderable resizable>
            <GridColumn
              field="approved"
              title="Approved"
              width="120px"
              // editable={true}
              // // cell={ CheckBox }
              // editor="boolean"
              cell={this.approvedCell}
            />
             
            <GridColumn
              field="name"
              title="Action Title"
              width="120px"
              // locked={true}
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
            />

            <GridColumn
              field="number"
              title="Action Number"
              width="150px"
              // locked={true}
            />
             <GridColumn
             field="createdDate"
             title="created Date"
             format="{0:dd-MMM-yyyy}"
             width="100px"
             editable={false}
           />
             <GridColumn
             field="createdByName"
             title="created By"
             width="100px"
             editable={false}
           />
            <GridColumn
              field="control"
              title="Description"
              width="150px"
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
            />
            <GridColumn
              field="externalReference"
              title="External Reference"
              width="150px"
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
            />
            <GridColumn
              field="actionType"
              title="Action Type"
              width="150px"
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
            />
            <GridColumn
              field="cost"
              title={ "Cost of Action / "+secureLocalStorage.getItem("currency")}
              width="80px"
              cell={(props) => <CurrencyFormat {...props} />}
            />
            <GridColumn
              field="reductionFrequency"
              title={this.props.dataItem.isOpportunity === "Opportunity"?"Increase in Probability (%)":"Reduction in Probability (%)"}
              width="120px"
              cell={(props) => <CurrencyFormat {...props} />}
            />
            {this.state.impactMitigationColumns}
            <GridColumn field="spi" title="% On Track" width="150px" />
            <GridColumn
              field="percentageCompletion"
              title="% Completion"
              width="100px"
            />
            <GridColumn
              field="originalCompletionDate"
              title="Original Completion Date"
              width="150px"
              format="{0:dd-MMM-yyyy}"
            />
            <GridColumn
              field="projectedCompletionDate"
              title="Projected Completion Date"
              width="150px"
              format="{0:dd-MMM-yyyy}"
            />
            <GridColumn
              field="actualCompletionDate"
              title="Actual Completion Date"
              width="150px"
              format="{0:dd-MMM-yyyy}"
            />
            <GridColumn
              field="delayConsequence"
              title="Delay Consequence"
              width="150px"
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
            />
            <GridColumn
              field="alertDescription"
              title="Alert Description"
              width="130px"
              cell={(props) => (
                <MitigationNameCell {...props} onEditCell={this.onEditCell} />
              )}
            />
            <GridColumn
              field="actionAlertStakeHolders"
              title="Alert StakeHolders"
              width="130px"
            />
            <GridColumn field="owner" width="100px" title="Owner" />
            <GridColumn field="status" width="100px" title="Comments" />
            <GridColumn
              field="isOpen"
              title="Status"
              width="80px"
              editor="boolean"
              cell={(props) => (
                <MitigationStatus {...props} onEditCell={this.onEditCell} />
              )}
            />
            <GridColumn field="departments" width="150px" title="Departments" />
            <GridColumn field="externalStatus" width="120px" title="External Status" />
            <GridColumn field="weeklyReport" width="100px" title="Weekly Report" />
          </Grid>
        </div>
      );
    }
    return (
      <div style={{ height: "50px", width: "100%" }}>
        <div style={{ position: "absolute", width: "100%" }}>
          <div className="k-loading-image" />
        </div>
      </div>
    );
  }
}
